import { styled } from "../../../../../../styles";

export const StepsChartDataContainer = styled("div", {
  width: "100%",
  height: "100%",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  variants: {
    isEmpty: {
      true: {
        opacity: 0.36,
      },
    },
  },
});

export const GraphContainer = styled("div", {
  width: "100%",
  height: "67%",

  // Empty state shrinks the graph area (matching the generic ChartCard's
  // 67%->57%) so the stats row lifts off the card's bottom margin.
  variants: {
    isEmpty: {
      true: {
        height: "57%",
      },
    },
  },
});

export const GraphLegend = styled("div", {
  width: "100%",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",

  marginBottom: "2px",
});

export const SourcesColumn = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  alignItems: "flex-start",
});
